import React, { useState } from 'react'
import { Typography, message } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { Modal } from '~/Components/Modal'
import { AxiosPromise } from 'axios'

const { Text } = Typography

interface DeleteCompanyModalProps {
  visible: boolean
  organizationId: string
  organizationName: string
  onClose: () => void
  onSuccess: () => void
  deleteService: (organizationId: string) => AxiosPromise<any>
}

export const DeleteCompanyModal: React.FC<DeleteCompanyModalProps> = ({
  visible,
  organizationId,
  organizationName,
  onClose,
  onSuccess,
  deleteService,
}) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const handleDelete = async () => {
    try {
      setLoading(true)
      await deleteService(organizationId)
      message.success(t('admin.deleteCompanySuccess'))
      onSuccess()
      onClose()
    } catch (error: any) {
      console.error('Error deleting organization:', error)
      message.error(
        error?.response?.data?.message || t('admin.deleteCompanyFailed'),
      )
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    onClose()
  }

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
          <span>{t('admin.deleteCompany')}</span>
        </div>
      }
      visible={visible}
      onCancel={handleCancel}
      onOk={handleDelete}
      confirmLoading={loading}
      width={500}
      okText={t('admin.delete')}
      cancelText={t('cancel')}
      loadingData={loading}
      destroyOnClose
      okButtonProps={{ danger: true }}
    >
      <div style={{ padding: '20px 0' }}>
        <Text>
          {t('admin.confirmDeleteOrganization')}{' '}
          <Text strong style={{ color: '#ff4d4f' }}>
            "{organizationName}"
          </Text>
          ?
        </Text>
        <br />
        <br />
        <Text type="warning">
          {t('admin.deleteWarning')}
        </Text>
      </div>
    </Modal>
  )
}